<template>
  <div class="editors" :style="{ height: contentHeight }">
    <div class="fixedS" ref="fixedS"></div>
    <template v-if="editor">
      <div class="tools" ref="toolNew">
        <EditLink
          :style="{
            position: screenX_ == '0px' || !defaultUrlText ? 'absolute' : 'fixed',
            left: !defaultUrlText ? '20px' : screenX_,
            top: !defaultUrlText ? 0 : screenY_ == '0px' ? 0 : screenY_
          }"
          v-if="showLink"
          :isEdit="defaultUrlText"
          @editLink="editLink"
          ref="refEditLink"
        ></EditLink>
        <div class="font fontS" v-if="!isSimpleText">
          <div class="clickBtn" @click="toShowSize">
            {{ defaultSize }}
            <i class="iconfont iconarrow_drop_down-24px"></i>
          </div>
          <div class="fontsMenu sizesMenu" v-if="showSize">
            <div
              v-for="(item, index) in sizes"
              @click="toSetSize(index)"
              :index="index"
              class="item"
              :class="{ selectedStyle: item == defaultSize }"
            >
              {{ item }}
            </div>
          </div>
        </div>
        <el-tooltip
          popper-class="customer-number-tooltip-popover table-tooltip"
          content="Bold"
          placement="top"
          :visible-arrow="false"
        >
          <button
            @click="editor.chain().focus().toggleBold().run()"
            :disabled="!editor.can().chain().focus().toggleBold().run()"
            :class="{ 'is-active': editor.isActive('bold') }"
          >
            <i class="iconfont iconformat_bold-24px"></i>
          </button>
        </el-tooltip>
        <el-tooltip
          popper-class="customer-number-tooltip-popover table-tooltip"
          content="Italic"
          placement="top"
          :visible-arrow="false"
        >
          <button
            @click="editor.chain().focus().toggleItalic().run()"
            :disabled="!editor.can().chain().focus().toggleItalic().run()"
            :class="{ 'is-active': editor.isActive('italic') }"
          >
            <i class="iconfont iconformat_italic-black-18dp"></i>
          </button>
        </el-tooltip>
        <el-tooltip
          popper-class="customer-number-tooltip-popover table-tooltip"
          content="Underline"
          placement="top"
          :visible-arrow="false"
        >
          <button
            @click="editor.chain().focus().toggleUnderline().run()"
            :class="{ 'is-active': editor.isActive('underline') }"
          >
            <i class="iconfont iconformat_underlined-black-18dp"></i>
          </button>
        </el-tooltip>

        <!-- <el-tooltip
          popper-class="customer-number-tooltip-popover table-tooltip"
          content="Text color"
          placement="top"
          :visible-arrow="false"
        >
          <button>
            <i class="iconfont icona-TextColorIcon" @click="toShowColor"></i>
            <colors
              type="font"
              :defaultColor="fontColor"
              @setColor="setColor"
              :showTop="false"
              v-if="showColor"
            ></colors>
          </button>
        </el-tooltip> -->

        <!-- <el-tooltip
          popper-class="customer-number-tooltip-popover table-tooltip"
          content="Text highlight"
          placement="top"
          :visible-arrow="false"
        >
          <button>
            <i class="iconfont iconcolor" @click="toShowBg"></i>
            <colors
              type="bg"
              :showTop="showTop"
              :defaultColor="bgColor"
              @setColor="setColor"
              v-if="showBgColor"
            ></colors>
          </button>
        </el-tooltip> -->
        <el-tooltip
          popper-class="customer-number-tooltip-popover table-tooltip"
          content="Text alignment"
          placement="top"
          :visible-arrow="false"
          :disabled="showText"
        >
          <button class="lists">
            <div class="clickB">
              <i class="iconfont" :class="defaultText" @click="toShowText"></i>
              <i class="iconfont iconarrow_drop_down-24px" @click="toShowText"></i>
            </div>

            <div class="listsMenu" v-if="showText">
              <div
                v-for="(item, index) in iconTexts"
                @click="toSetText(index)"
                :key="index"
                class="item"
                :class="{ selectedStyle: item == defaultText }"
              >
                <i class="iconfont" :class="item"></i>
              </div>
            </div>
          </button>
        </el-tooltip>
        <el-tooltip
          popper-class="customer-number-tooltip-popover table-tooltip"
          content="List styles"
          placement="top"
          :visible-arrow="false"
          :disabled="showList"
        >
          <button class="lists">
            <div class="clickB">
              <i class="iconfont" :class="defaultList" @click="toShowList"></i>
              <i class="iconfont iconarrow_drop_down-24px" @click="toShowList"></i>
            </div>

            <div class="listsMenu" v-if="showList">
              <div
                v-for="(item, index) in iconLists"
                @click="toSetList(index)"
                :key="index"
                class="item"
                :class="{ selectedStyle: item == defaultList }"
              >
                <i class="iconfont" :class="item"></i>
              </div>
            </div>
          </button>
        </el-tooltip>

        <el-tooltip
          popper-class="customer-number-tooltip-popover table-tooltip"
          content="Clear formatting"
          placement="top"
          :visible-arrow="false"
        >
          <button @click="toRevert">
            <i class="iconfont icona-RemoveFormattingIcon"></i>
          </button>
        </el-tooltip>

        <p class="line"></p>
        <el-tooltip
          popper-class="customer-number-tooltip-popover table-tooltip"
          content="Insert link"
          placement="top"
          :visible-arrow="false"
        >
          <button @click="setLink" :class="{ 'is-active': editor.isActive('link') }">
            <i class="iconfont icona-LinkIcon1"></i>
          </button>
        </el-tooltip>
        <el-tooltip
          popper-class="customer-number-tooltip-popover table-tooltip"
          content="Emoji"
          placement="top"
          :visible-arrow="false"
        >
          <button @click="emojiCom = true" v-if="showEmoji">
            <i class="iconfont icona-emojiicon"></i>
            <InsertEmoji
              @handleSelect="handleSelect"
              @closeEmoji="closeEmoji"
              v-if="emojiCom"
              :showTop="emojiTop"
            ></InsertEmoji>
          </button>
        </el-tooltip>
        <el-tooltip
          popper-class="customer-number-tooltip-popover table-tooltip"
          content="Insert image"
          placement="top"
          :visible-arrow="false"
        >
          <button>
            <el-upload
              class="upload-demo"
              multiple
              :auto-upload="false"
              :show-file-list="false"
              :before-upload="beforeImgUpload"
              :on-success="handleImgSuccess"
              action="/media/public/file/uploadExt"
              accept=".jpg,.png,.jpeg"
              :on-change="uploadFileChange"
              :on-progress="uploadProcess"
            >
              <i class="iconfont iconphotoUp" style="vertical-align: 0"></i>
            </el-upload>
          </button>
        </el-tooltip>

        <el-tooltip
          popper-class="customer-number-tooltip-popover table-tooltip"
          content="Insert video"
          placement="top"
          :visible-arrow="false"
        >
          <button :disabled="videoUploading">
            <el-upload
              ref="videoUpload"
              class="upload-demo"
              action=""
              multiple
              :auto-upload="false"
              :show-file-list="false"
              :file-list="videoFileList"
              :accept="videoAccept"
              :disabled="videoUploading"
              :on-change="uploadVideoFileChange"
            >
              <i class="iconfont iconCam_On"></i>
            </el-upload>
          </button>
        </el-tooltip>

        <el-tooltip
          popper-class="customer-number-tooltip-popover table-tooltip"
          content="Add attachment"
          placement="top"
          :visible-arrow="false"
        >
          <button v-if="upload">
            <el-upload
              :show-file-list="false"
              class="upload-demo"
              :auto-upload="false"
              action=""
              accept="image/jpeg,image/png,application/pdf"
              :on-change="
                (file, fileList) => {
                  onUploadFileChange(file, fileList)
                }
              "
            >
              <i class="iconfont iconupload"></i>
            </el-upload>
          </button>
        </el-tooltip>
      </div>
    </template>

    <editor-content
      class="content"
      ref="editor"
      :editor="editor"
      :style="{
        height: height,
        minHeight: minHeight ? minHeight + 'px' : 'auto',
        maxHeight: maxHeight ? maxHeight + 'px' : 'auto'
      }"
    />

    <div class="video-upload-state" v-if="videoUploading">
      <span>Uploading video {{ videoUploadProgress }}%</span>
      <el-progress :percentage="videoUploadProgress" :show-text="false"></el-progress>
    </div>

    <div class="modal" v-if="fileData.length">
      <div class="modal-item" v-for="(item, index) in fileData">
        <i class="iconfont iconattach_file-24px"></i>
        <el-tooltip
          popper-class="customer-number-tooltip-popover table-tooltip"
          :content="item.url.split('name=')[1]"
          placement="top"
          :visible-arrow="false"
        >
          <span class="name" @click="toHref(item.url)">{{ item.url.split('name=')[1] }}</span>
        </el-tooltip>
        <span class="size">({{ Math.round(item.size / 1000) }}K)</span>
        <i class="iconfont iconClose_24px" @click="clearFile(index)"></i>
      </div>
    </div>
  </div>
</template>

<script>
import Placeholder from '@tiptap/extension-placeholder'
import colors from './colors'
import EditLink from './EditLink'
import BulletList from '@tiptap/extension-bullet-list'
import ListItem from '@tiptap/extension-list-item'
import OrderedList from '@tiptap/extension-ordered-list'
import Mention from '@tiptap/extension-mention'
import TextAlign from '@tiptap/extension-text-align'
import Document from '@tiptap/extension-document'
import FontFamily from '@tiptap/extension-font-family'
import Image from '@tiptap/extension-image'
import Paragraph from '@tiptap/extension-paragraph'
import Background from '../../../common/backgroundColor'
import FontSize from '../../../common/fontSize'
import Highlight from '@tiptap/extension-highlight'
import Text from '@tiptap/extension-text'
import Link from '@tiptap/extension-link'
import TextStyle from '@tiptap/extension-text-style'
import Color from '@tiptap/extension-color'
import ImageWithTools from '../../../common/imgae'
import VideoWithTools, {
  uploadAnnouncementVideo,
  validateAnnouncementVideoSelection
} from '@/common/video'
import { VIDEO_ACCEPT } from '@/common/video/videoUploadCore'
import Underline from '@tiptap/extension-underline'
import createSuggestion from './suggestion'
import StarterKit from '@tiptap/starter-kit'
import { Editor, EditorContent } from '@tiptap/vue-2'
import Emoji, { gitHubEmojis } from '../../../common/extension-emoji'
import InsertEmoji from './InsertEmoji'
import { Ajax } from '@/common'
import imageCompression from 'browser-image-compression'
// import Personalize from './Personalize.vue';

// import { BaseUrl } from '@/service/request';

export default {
  components: {
    EditorContent,
    colors,
    EditLink,
    InsertEmoji
    // Personalize
  },
  props: {
    limitNumber: {
      type: Number,
      default: 0
    },
    isSureBtnDisabled: {
      type: Boolean,
      default: false
    },
    showEmoji: {
      type: Boolean,
      default: true
    },
    placeholderPadding: {
      type: Boolean,
      default: false
    },
    itemIndex: {
      type: Number,
      default: 0
    },
    height: {
      type: String,
      default: 'auto'
    },
    contentHeight: {
      type: String,
      default: 'auto'
    },
    type: {
      type: String,
      default: ''
    },
    upload: {
      type: Boolean,
      default: false
    },
    emojiTop: {
      type: Boolean,
      default: true
    },
    minHeight: {
      type: Number,
      default: 0
    },
    maxHeight: {
      type: Number,
      default: 0
    },
    content: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    includeMention: {
      type: Boolean,
      default: true
    },
    userList: {
      type: Array,
      default: () => []
    },
    uploadImg: {
      type: Boolean,
      default: true
    },
    toolRight: {
      type: Boolean,
      default: false
    },
    showTextTool: {
      type: Boolean,
      default: true
    },
    onlyLink: {
      type: Boolean,
      default: false
    },
    isSimpleText: {
      type: Boolean,
      default: true
    },
    onlyEmoji: {
      type: Boolean,
      default: false
    },
    onlyPersonalize: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      emojiCom: false,
      fileData: [],
      videoAccept: VIDEO_ACCEPT,
      videoFileList: [],
      videoUploading: false,
      videoUploadProgress: 0,
      videoUploadController: null,
      pendingVideoValidationTimer: null,
      pendingVideoValidationToken: 0,
      uploadUrl: `/media/public/file/upload`,
      uploadUrlExt: '/media/public/file/uploadExt',
      editor: null,
      fonts: ['OpenSans', 'Georgia', 'Tahoma', 'Trebuchet MS', 'Verdana'],
      iconTexts: [
        'icona-Align_LeftIcon',
        'icona-Align_CenterIcon',
        'icona-Align_JustifyIcon',
        'icona-Align_RightIcon'
      ],
      defaultText: 'icona-Align_LeftIcon',
      iconLists: ['icona-List_BulletIcon', 'icona-List_NumberIcon'],
      defaultList: 'icona-List_BulletIcon',
      sizes: [12, 14, 18, 24, 36],
      defaultFont: 'OpenSans',
      defaultSize: 14,
      showMore: false,
      showFonts: false,
      showColor: false,
      showBgColor: false,
      showSize: false,
      showText: false,
      showList: false,
      showLink: false,
      fontColor: '#33475b',
      bgColor: 'rgb(255, 255, 255)',
      currentSelection: 1,
      linkRange: null,
      defaultUrlText: '',
      defaultUrlUrl: '',
      screenX_: 0,
      screenY_: 0,
      showTop: false,
      canSetLink: true,
      currentText: ''
    }
  },
  computed: {
    fileHeight() {
      let num = 0
      if (this.height) {
        if (this.fileData.length) {
          num = 64
          if (this.fileData.length > 5) {
            num = num + Math.ceil((this.fileData.length - 5) / 5) * 44
          }
        }
      } else {
        if (this.fileData.length) {
          num = 64
          if (this.fileData.length > 2) {
            num = num + Math.ceil((this.fileData.length - 2) / 2) * 44
          }
        }
      }
      this.$emit('setFile', this.fileData)
      return num
    }
  },
  created() {
    this.uploadUrl =
      process.env.NODE_ENV === 'production' ? this.uploadUrl : '/classnovo' + this.uploadUrl
    this.uploadUrlExt =
      process.env.NODE_ENV === 'production' ? this.uploadUrlExt : '/classnovo' + this.uploadUrlExt
  },

  mounted() {
    let that = this
    // const CustomMark = Mark.create({
    //   name: 'customMark'
    //
    //   // Your code goes here.
    // });
    console.log('content', this.content)
    const suggestion = createSuggestion(() => this.userList)
    this.editor = new Editor({
      editable: !this.isSureBtnDisabled,
      extensions: [
        Link.configure({
          openOnClick: false
        }),
        Document,
        Paragraph,
        Text,
        TextStyle,
        FontFamily,
        Image.configure({
          inline: true
        }),
        ImageWithTools,
        VideoWithTools,
        Underline,
        StarterKit,
        BulletList,
        OrderedList,
        ListItem,
        Color,
        Background,
        FontSize,
        Emoji.configure({
          emojis: gitHubEmojis,
          enableEmoticons: true,
          suggestion
        }),
        Highlight.configure({ multicolor: true }),
        Placeholder.configure({
          // Use a placeholder:
          placeholder: this.placeholder,
          emptyNodeClass: 'my-custom-is-empty-class'
          // Use different placeholders depending on the node type:
          // placeholder: ({ node }) => {
          //   if (node.type.name === 'heading') {
          //     return 'What’s the title?'
          //   }

          //   return 'Can you add some further context?'
          // },
        }),
        TextAlign.configure({
          types: ['heading', 'paragraph']
        }),
        Mention.configure({
          HTMLAttributes: {
            class: 'mention'
          },
          suggestion
        })
      ],
      content: this.content,
      editorProps: {
        handlePaste(view, event) {
          return that.handleEditorPaste(view, event)
        },
        handleDrop(view, event, slice, moved) {
          return that.handleEditorDrop(view, event, moved)
        },
        transformPastedHTML(html) {
          if (typeof html !== 'string') {
            return ''
          }
          return html
        }
      },
      onUpdate({ editor }) {
        // The content has changed.
      }
    })
    this.editor.chain().focus().setFontFamily(this.defaultFont).run()
    this.editor
      .chain()
      .focus()
      .setFontSize(this.defaultSize + 'px')
      .run()
    this.editor.chain().focus().setColor('#33475B').run()
    this.editor.on('update', this.onUpdate)
    this.editor.on('blur', this.onBlur)
    this.editor.on('focus', this.onFocus)
    this.editor.on('selectionUpdate', this.onSelectionUpdate)
    // this.editor.on("paste", function ({ event, editor }) {
    //   console.log("handlePaste", event, event.preventDefault);
    //   event.preventDefault();
    //   // cancel paste
    //   // get text representation of clipboard
    //   var text = (event.originalEvent || event).clipboardData.getData(
    //     "text/plain"
    //   );
    //   editor.chain().focus().setContent(text).run();
    //   // editor.commands.paste(text, { plainText: true });
    // });

    setTimeout(() => {
      this.getPoi()
      this.$emit(
        'setHtml',
        this.editor.getHTML(),
        this.editor.getText().length,
        this.editor.getText()
      )
      this.$emit('setText', this.editor.getText())
    }, 1000)
  },
  beforeDestroy() {
    this.clearPendingVideoValidation()
    if (this.videoUploadController) {
      this.videoUploadController.abort()
    }
    if (this.editor) {
      this.editor.destroy()
    }
  },
  methods: {
    clearPendingVideoValidation() {
      if (this.pendingVideoValidationTimer) {
        clearTimeout(this.pendingVideoValidationTimer)
        this.pendingVideoValidationTimer = null
      }
      this.pendingVideoValidationToken += 1
    },
    resetVideoSelection() {
      this.videoFileList = []
      if (this.$refs.videoUpload) {
        this.$refs.videoUpload.clearFiles()
      }
    },
    escapeVideoDialogText(value) {
      return String(value || 'Unknown file').replace(/[&<>"']/g, (character) => {
        return {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        }[character]
      })
    },
    formatVideoFileSize(size) {
      return `${(Math.max(0, Number(size) || 0) / 1024 / 1024).toFixed(2)}MB`
    },
    showVideoValidationDialog(message, title) {
      return this.$confirm(message, title, {
        dangerouslyUseHTMLString: true,
        showConfirmButton: false,
        showCancelButton: false,
        showClose: true,
        closeOnClickModal: true,
        customClass: 'gg_confirm announcement_video_validation'
      }).catch(() => undefined)
    },
    async showVideoValidationErrors(validation) {
      if (validation.durationErrors.length) {
        const fileNames = validation.durationErrors
          .map((item) => this.escapeVideoDialogText(item.name))
          .join('<br>')
        await this.showVideoValidationDialog(
          `The video duration must be 120 seconds and below.<br><br>Files not meeting the duration requirement:<br><br>${fileNames}`,
          'Video duration not supported'
        )
      }

      if (validation.totalSizeError) {
        const fileContributions = validation.totalSizeError.files
          .map((item) => {
            return `${this.escapeVideoDialogText(
              item.name
            )} (${this.formatVideoFileSize(item.size)})`
          })
          .join('<br>')
        await this.showVideoValidationDialog(
          `The total size of selected videos exceeds the maximum limit of 500MB.<br><br>Files contributing to the limit:<br><br>${fileContributions}`,
          'Total upload size exceeded'
        )
      }
    },
    setVideoUploading(isUploading) {
      this.videoUploading = isUploading
      this.$emit('uploading-change', isUploading)
    },
    uploadVideoFileChange(file, fileList) {
      if (this.videoUploading || !file || !file.raw) {
        return
      }

      const nextFileList = [...(fileList || [])]
      const files = nextFileList.map((item) => item && item.raw).filter(Boolean)
      const validationToken = ++this.pendingVideoValidationToken
      this.videoFileList = nextFileList

      if (this.pendingVideoValidationTimer) {
        clearTimeout(this.pendingVideoValidationTimer)
      }
      this.pendingVideoValidationTimer = setTimeout(async () => {
        try {
          const validation = await validateAnnouncementVideoSelection(files)
          if (validationToken !== this.pendingVideoValidationToken) {
            return
          }

          if (validation.durationErrors.length || validation.totalSizeError) {
            await this.showVideoValidationErrors(validation)
            if (validationToken === this.pendingVideoValidationToken) {
              this.resetVideoSelection()
              this.clearPendingVideoValidation()
            }
            return
          }

          this.clearPendingVideoValidation()
          await this.uploadVideoFiles(files)
        } catch (error) {
          if (validationToken !== this.pendingVideoValidationToken) {
            return
          }
          this.resetVideoSelection()
          this.clearPendingVideoValidation()
          const message = (error && error.message) || 'Unable to validate the selected videos.'
          this.$message.error(message)
        }
      }, 0)
    },
    async uploadVideoFiles(files) {
      if (!files.length) {
        this.resetVideoSelection()
        return
      }

      this.videoUploadProgress = 0
      this.videoUploadController =
        typeof AbortController !== 'undefined' ? new AbortController() : null
      this.setVideoUploading(true)

      try {
        for (let index = 0; index < files.length; index += 1) {
          const result = await uploadAnnouncementVideo(files[index], {
            signal: this.videoUploadController ? this.videoUploadController.signal : undefined,
            onProgress: (progress) => {
              this.videoUploadProgress = Math.round(((index + progress / 100) / files.length) * 100)
            }
          })
          this.editor
            .chain()
            .focus()
            .setVideo({
              src: result.src,
              poster: result.poster,
              width: 'auto'
            })
            .run()
        }
      } catch (error) {
        const message = (error && error.message) || 'Video upload failed. Please try again.'
        if (this.$message && this.$message.error) {
          this.$message.error(message)
        } else {
          console.error(message)
        }
      } finally {
        this.videoUploadController = null
        this.videoUploadProgress = 0
        this.resetVideoSelection()
        this.setVideoUploading(false)
      }
    },
    async uploadFileChange(file, a) {
      if (!file || !file.raw) {
        return
      }
      await this.insertImageFile(file.raw)
    },
    handleEditorPaste(view, event) {
      try {
        const clipboardData = event && event.clipboardData
        if (!clipboardData) {
          return false
        }

        const html = clipboardData.getData('text/html')
        const imageFiles = Array.from(clipboardData.items || [])
          .filter((item) => item.type && item.type.indexOf('image/') === 0)
          .map((item) => item.getAsFile())
          .filter(Boolean)
        const imageUrl = this.getImageUrlFromClipboard(clipboardData)

        if (html && html.indexOf('<img') > -1) {
          event.preventDefault()
          void this.processPastedHtml(html)
          return true
        }

        if (imageFiles.length) {
          event.preventDefault()
          void this.processPastedImageFiles(imageFiles)
          return true
        }

        if (imageUrl) {
          event.preventDefault()
          void this.insertImageSource(imageUrl)
          return true
        }
      } catch (error) {
        console.error('Error handling pasted image:', error)
      }

      return false
    },
    async processPastedHtml(html) {
      const imageSources = this.getImageSourcesFromHtml(html)
      if (imageSources.length && this.isImageOnlyHtml(html)) {
        for (const source of imageSources) {
          await this.insertImageSource(source)
        }
        return
      }

      const processedHtml = await this.prepareRichHtmlWithImages(html)
      if (processedHtml) {
        this.editor.chain().focus().insertContent(processedHtml).run()
        return
      }

      for (const source of imageSources) {
        await this.insertImageSource(source)
      }
    },
    async processPastedImageFiles(imageFiles) {
      for (const file of imageFiles) {
        await this.insertImageFile(file)
      }
    },
    async handleEditorDrop(view, event, moved) {
      if (moved) {
        return false
      }

      const dataTransfer = event && event.dataTransfer
      if (!dataTransfer) {
        return false
      }

      const html = dataTransfer.getData('text/html')
      const imageFiles = Array.from(dataTransfer.files || []).filter(
        (file) => file.type && file.type.indexOf('image/') === 0
      )
      const imageSources = this.getImageSourcesFromHtml(html)
      if (!imageFiles.length && !imageSources.length) {
        return false
      }

      event.preventDefault()
      this.setSelectionFromEvent(view, event)

      if (html && html.indexOf('<img') > -1) {
        const processedHtml = await this.prepareRichHtmlWithImages(html)
        this.editor.chain().focus().insertContent(processedHtml).run()
        return true
      }

      for (const file of imageFiles) {
        await this.insertImageFile(file)
      }
      return true
    },
    setSelectionFromEvent(view, event) {
      const position = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
      })
      if (position && typeof position.pos === 'number') {
        this.editor.commands.setTextSelection(position.pos)
      }
    },
    getImageSourcesFromHtml(html) {
      if (!html) {
        return []
      }

      const container = document.createElement('div')
      container.innerHTML = html
      const sources = []
      const images = Array.from(container.querySelectorAll('img'))
      images.forEach((item) => {
        ;[
          item.getAttribute('src'),
          item.getAttribute('data-src'),
          item.getAttribute('data-original'),
          item.getAttribute('data-actualsrc'),
          this.getFirstUrlFromSrcSet(item.getAttribute('srcset'))
        ]
          .filter((src) => !!src)
          .forEach((src) => {
            if (sources.indexOf(src) === -1) {
              sources.push(src)
            }
          })
      })

      const backgroundNodes = Array.from(container.querySelectorAll('[style]'))
      backgroundNodes.forEach((item) => {
        const backgroundUrl = this.getBackgroundImageUrl(item.getAttribute('style'))
        if (backgroundUrl && sources.indexOf(backgroundUrl) === -1) {
          sources.push(backgroundUrl)
        }
      })

      return sources
    },
    isImageOnlyHtml(html) {
      if (!html) {
        return false
      }

      const container = document.createElement('div')
      container.innerHTML = html
      const text = (container.textContent || '').replace(/\s+/g, '')
      return !text
    },
    getImageUrlFromClipboard(clipboardData) {
      const uriList = clipboardData.getData('text/uri-list')
      const uriCandidate = this.getFirstUrlFromText(uriList)
      if (this.isPotentialImageSource(uriCandidate, true)) {
        return uriCandidate
      }

      const plainText = clipboardData.getData('text/plain')
      const plainCandidate = this.getFirstUrlFromText(plainText)
      if (this.isPotentialImageSource(plainCandidate, false)) {
        return plainCandidate
      }

      return ''
    },
    getFirstUrlFromText(text) {
      if (!text) {
        return ''
      }

      const lines = text
        .split(/\r?\n/)
        .map((item) => item.trim())
        .filter((item) => item && item.indexOf('#') !== 0)
      return lines[0] || ''
    },
    getFirstUrlFromSrcSet(srcSet) {
      if (!srcSet) {
        return ''
      }

      const firstPart = srcSet
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean)[0]
      if (!firstPart) {
        return ''
      }

      return firstPart.split(/\s+/)[0] || ''
    },
    getBackgroundImageUrl(styleText) {
      if (!styleText) {
        return ''
      }

      const match = styleText.match(/background-image\s*:\s*url\((['"]?)(.*?)\1\)/i)
      return match && match[2] ? match[2] : ''
    },
    isPotentialImageSource(value, acceptHttpUrl) {
      if (!value) {
        return false
      }

      if (value.indexOf('data:image/') === 0 || value.indexOf('blob:') === 0) {
        return true
      }

      if (!/^https?:\/\//i.test(value)) {
        return false
      }

      if (acceptHttpUrl) {
        return true
      }

      return /\.(apng|avif|gif|jpe?g|png|svg|webp|bmp)(\?.*)?$/i.test(value)
    },
    async prepareRichHtmlWithImages(html) {
      const container = document.createElement('div')
      container.innerHTML = html
      const images = Array.from(container.querySelectorAll('img'))
      for (const image of images) {
        const src =
          image.getAttribute('src') ||
          image.getAttribute('data-src') ||
          image.getAttribute('data-original') ||
          image.getAttribute('data-actualsrc') ||
          this.getFirstUrlFromSrcSet(image.getAttribute('srcset'))
        const newSrc = await this.resolveImageSourceForEditor(src)
        if (newSrc) {
          image.setAttribute('src', newSrc)
        } else {
          image.remove()
        }
      }
      return container.innerHTML || ''
    },
    async resolveImageSourceForEditor(src) {
      if (!src) {
        return ''
      }
      if (src.indexOf('data:image/') === 0) {
        const file = this.dataUrlToFile(src)
        if (!file) {
          return ''
        }
        return this.uploadPreparedImage(file)
      }
      if (src.indexOf('blob:') === 0) {
        return this.uploadRemoteImageSource(src)
      }
      if (/^https?:\/\//i.test(src)) {
        return src
      }
      return src
    },
    async insertImageSource(src) {
      if (!src) {
        return
      }

      if (src.indexOf('data:image/') === 0) {
        const file = this.dataUrlToFile(src)
        if (file) {
          await this.insertImageFile(file)
        }
        return
      }

      const resolvedSrc = await this.resolveImageSourceForEditor(src)
      if (resolvedSrc) {
        this.addImage(resolvedSrc)
      }
    },
    dataUrlToFile(dataUrl) {
      try {
        const parts = dataUrl.split(',')
        if (parts.length < 2) {
          return null
        }
        const mimeMatch = parts[0].match(/data:(.*?);base64/)
        const mimeType = mimeMatch && mimeMatch[1] ? mimeMatch[1] : 'image/png'
        const byteString = atob(parts[1])
        const length = byteString.length
        const bytes = new Uint8Array(length)
        for (let index = 0; index < length; index += 1) {
          bytes[index] = byteString.charCodeAt(index)
        }
        const extension = mimeType.split('/')[1] || 'png'
        return new File([bytes], `pasted-image.${extension}`, {
          type: mimeType,
          lastModified: Date.now()
        })
      } catch (error) {
        console.error('Error converting pasted image:', error)
        return null
      }
    },
    blobToFile(blob, fileName) {
      return new File([blob], fileName, {
        type: blob.type || 'image/png',
        lastModified: Date.now()
      })
    },
    isImageMimeType(mimeType) {
      return !!mimeType && /^image\//i.test(mimeType)
    },
    shouldCompressImage(mimeType) {
      return ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/bmp'].includes(
        (mimeType || '').toLowerCase()
      )
    },
    inferMimeTypeFromSource(src) {
      if (!src) {
        return ''
      }

      const lowerSrc = src.toLowerCase()
      if (lowerSrc.indexOf('.png') > -1) {
        return 'image/png'
      }
      if (lowerSrc.indexOf('.jpg') > -1 || lowerSrc.indexOf('.jpeg') > -1) {
        return 'image/jpeg'
      }
      if (lowerSrc.indexOf('.gif') > -1) {
        return 'image/gif'
      }
      if (lowerSrc.indexOf('.webp') > -1) {
        return 'image/webp'
      }
      if (lowerSrc.indexOf('.bmp') > -1) {
        return 'image/bmp'
      }
      if (lowerSrc.indexOf('.svg') > -1) {
        return 'image/svg+xml'
      }
      if (lowerSrc.indexOf('.avif') > -1) {
        return 'image/avif'
      }

      return ''
    },
    getImageExtensionFromMimeType(mimeType) {
      const extension = (mimeType || 'image/png').split('/')[1] || 'png'
      return extension.replace(/[^a-z0-9]/gi, '') || 'png'
    },
    async uploadRemoteImageSource(src) {
      const response = await fetch(src)
      if (!response.ok) {
        throw new Error(`Fetch image failed: ${response.status}`)
      }

      const blob = await response.blob()
      const headerMimeType = response.headers.get('content-type') || ''
      const mimeType =
        blob.type || headerMimeType.split(';')[0] || this.inferMimeTypeFromSource(src)
      if (!this.isImageMimeType(mimeType)) {
        throw new Error('Fetched remote content is not an image')
      }

      const extension = this.getImageExtensionFromMimeType(mimeType)
      const normalizedBlob = blob.type ? blob : new Blob([blob], { type: mimeType })
      const file = this.blobToFile(normalizedBlob, `pasted-remote-image.${extension}`)
      return this.uploadPreparedImage(file)
    },
    async compressImageFile(file) {
      if (!file) {
        throw new Error('Image file is required')
      }

      if (!this.isImageMimeType(file.type) || !this.shouldCompressImage(file.type)) {
        return file
      }

      const options = {
        maxSizeMB: 1,
        alwaysKeepResolution: true,
        maxWidthOrHeight: 1920,
        useWebWorker: false
      }
      return imageCompression(file, options)
    },
    async uploadEditorImage(file) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('multipartFile', file)

      const res = await Ajax.post('/media/public/file/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      if (res.code !== '0000') {
        throw new Error(res.message || 'Upload image failed')
      }

      return `${process.env.VUE_APP_fileBasePath}${res.data.filePath}`
    },
    async uploadPreparedImage(file) {
      let uploadFile = file
      try {
        uploadFile = await this.compressImageFile(file)
      } catch (error) {
        console.error('Error compressing image:', error)
      }
      return this.uploadEditorImage(uploadFile)
    },
    async insertImageFile(file) {
      try {
        const imageUrl = await this.uploadPreparedImage(file)
        this.addImage(imageUrl)
      } catch (error) {
        console.error('Error uploading image:', error)
        this.$message({
          message: 'Image upload failed',
          type: 'warning'
        })
      }
    },
    onUploadFileChange(file, fileList) {
      const isLt100M = file.size / 1024 / 1024 < 100 //这里做文件大小限制
      console.log(isLt100M)
      if (!isLt100M) {
        this.$message({
          message: 'Upload files should not exceed 100MB',
          type: 'warning'
        })
        return isLt100M
      }
      // this.loading = true;
      if (file) {
        let fileName = file.name
        let formData = new FormData()
        formData.append('file', file)
        formData.append('multipartFile', file.raw)
        Ajax.post(
          // "/media/public/file/upload",
          '/media/public/file/uploadExt',
          formData,
          {
            headers: { 'Content-Type': 'multipart/form-data' }
          }
        )
          .then((res) => {
            if (res.code === '0000') {
              let imgSrc = `${process.env.VUE_APP_fileBasePath}${res.data.filePath}`
              console.log(file)
              let data = file
              data.fileName = fileName
              data.src = imgSrc
              data.id = res.data.requestId

              this.$emit('setFile', data)
              // this.fileList.push({
              //   fileName,
              //   src: imgSrc,
              //   id: res.data.requestId,
              // });
            }
          })
          .catch((err) => {
            this.loading = false
          })
      }
    },
    handleInsertPers(insertData) {
      let alt = insertData.contact + '_' + insertData.key,
        imgSrc = 'https://edoovo-hk.oss-cn-hongkong.aliyuncs.com/webStatic/images/lastname.png'
      if (insertData.contact == 'Parents') {
        if (insertData.insertToken == 'First name') {
          imgSrc = 'https://edoovo-hk.oss-cn-hongkong.aliyuncs.com/webStatic/images/firstname.png'
        }
      } else {
        if (insertData.insertToken == 'First name') {
          imgSrc = 'https://edoovo-hk.oss-cn-hongkong.aliyuncs.com/webStatic/images/firstname.png'
        }
      }
      this.editor.chain().focus().setImage({ src: imgSrc, alt: alt }).run()
      this.$nextTick(() => {
        this.$emit('changePersonalize', insertData)
      })
    },
    closeEmoji() {
      this.emojiCom = false
    },
    handleSelect(value) {
      this.editor.chain().focus().setEmoji(value.words[0]).run()
      setTimeout(() => {
        this.emojiCom = false
        console.log(222)
      }, 100)
    },
    toHref(link) {
      window.open(link)
    },
    clearFile(index) {
      this.fileData.splice(index, 1)
      this.$emit('setFile', this.fileData)
    },
    getPoi() {
      const selection = window.getSelection()
      if (selection.rangeCount === 0) {
        return false
      }
      // 获取选中区域的范围 获取光标的范围
      const range = selection.getRangeAt(0)
      // 获取选中区域的边界 获取当前光标的坐标点 这个方法里面都有getBoundingClientRect()
      const { top, left } = range.getBoundingClientRect()
      // 获取当前光标的位置
      const cursorPosition = {
        x: left,
        y: top + range.getBoundingClientRect().height
      }
      console.log(cursorPosition.x)
      this.screenX_ = cursorPosition.x + 'px'
      let heightS = this.$refs.fixedS && this.$refs.fixedS.offsetHeight
      if (cursorPosition.y > heightS) {
        this.showTop = true
        this.screenY_ = cursorPosition.y - heightS + 'px'
      } else {
        if (cursorPosition.y != 0) {
          this.showTop = false
        }
        this.screenY_ = cursorPosition.y + 'px'
      }
    },
    onSelectionUpdate(data) {
      this.currentText = window.getSelection().toString()
      this.currentSelection = data.transaction.curSelection.$anchor.pos
      this.getPoi()
      if (!this.canSetLink) {
        return
      }
      if (this.editor.isActive('link') && !this.showLink) {
        if (!this.editor.getAttributes('link').class) {
          let html = this.editor.getHTML(),
            html1 = '',
            newText = this.editor.getAttributes('link').href
          html = this.editor
            .getHTML()
            .split(
              `<a target="_blank" rel="noopener noreferrer nofollow" href="${
                this.editor.getAttributes('link').href
              }">`
            )
          if (html.length > 1) {
            html1 = html[1].split('</a>')
            html1[0] = ''
          }
          let data =
            html[0] +
            `<a target="_blank" rel="noopener noreferrer nofollow" class="${newText.replace(
              'http://',
              ''
            )}" href="${newText}">${newText.replace('http://', '')}` +
            html1.join('</a>')
          console.log(data)
          this.editor.commands.clearContent()
          this.editor.commands.setContent(data)
          return
        }
        this.showLink = true
        this.editor.commands.extendMarkRange('link')
        const { from, to } = this.editor.state.selection
        this.linkRange = { from, to }

        this.$nextTick(() => {
          this.$refs.refEditLink.setData(
            this.editor.getAttributes('link').class,
            this.editor.getAttributes('link').href,
            this.editor.getAttributes('link').target == '_blank'
          )
          this.defaultUrlText = this.editor.getAttributes('link').class
          this.defaultUrlUrl = this.editor.getAttributes('link').href
        })
      } else if (!this.editor.isActive('link')) {
        this.showLink = false
      }
    },
    onFocus(data) {
      this.$emit('onFocus')
    },
    onUpdate() {
      this.showMore = false
      this.closeAll()
      if (this.limitNumber) {
        if (this.editor.getText().length === this.limitNumber) {
          this.htmlData_ = this.editor.getHTML()
        } else if (this.editor.getText().length > this.limitNumber) {
          this.editor.commands.setContent(this.htmlData_)
        }
      }
      console.log(this.editor.getHTML())
      this.$emit(
        'setHtml',
        this.editor.getHTML(),
        this.editor.getText().length,
        this.editor.getText()
      )
      this.$emit('setText', this.editor.getText(), this.editor.getText().length)
      if (this.editor.getHTML() == '<p></p>') {
        this.editor.chain().focus().setFontFamily(this.defaultFont).run()
      }
    },
    clearHtml() {
      this.editor.commands.clearContent()
      this.editor.chain().focus().setFontFamily(this.defaultFont).run()
    },
    editLink(text, url, open, sureDelete) {
      this.canSetLink = false
      if (sureDelete) {
        // let content = this.editor.getText();
        // console.log(this.editor.getText());
        // let num = content.indexOf(this.defaultUrlText) + 1;
        // this.currentSelection = num;
        // // this.editor.commands.selectParentNode();
        // this.editor.commands.selectTextblockStart();
        this.editor.commands.unsetLink()
        // setTimeout(() => {
        //   this.editor.commands.insertContentAt(this.currentSelection, `${text}`, {
        //     updateSelection: true,
        //     parseOptions: {
        //       preserveWhitespace: 'full'
        //     }
        //   });
        // }, 100);

        // this.editor.commands.deleteSelection();
      }
      let newText = text
      if (text && !sureDelete) {
        let newUrl = ''

        if (typeof text !== 'string') {
          newText = text.toString()
        }
        if (url.indexOf('http') > -1) {
          newUrl = url
        } else {
          newUrl = 'http://' + url
        }
        if (this.defaultUrlText) {
          const range = this.linkRange || this.editor.state.selection
          this.editor.commands.insertContentAt(
            { from: range.from, to: range.to },
            {
              type: 'text',
              text: newText,
              marks: [
                {
                  type: 'link',
                  attrs: {
                    href: newUrl,
                    target: open ? '_blank' : '_self',
                    rel: 'noopener noreferrer nofollow',
                    class: newText
                  }
                }
              ]
            }
          )

          this.showLink = false
          this.defaultUrlText = ''
          this.defaultUrlUrl = ''
          this.linkRange = null
          setTimeout(() => {
            this.canSetLink = true
            this.$emit(
              'setHtml',
              this.editor.getHTML(),
              this.editor.getText().length,
              this.editor.getText()
            )
            this.$emit('setText', this.editor.getText())
          }, 200)
          return
        } else if (this.currentText) {
          const content =
            this.editor && typeof this.editor.getText === 'function'
              ? this.editor.getText() || ''
              : ''
          const selection = typeof this.currentSelection === 'number' ? this.currentSelection : 0
          const num = this.currentText.length
          if (content && selection > 0 && num > 0) {
            const afterText = content.slice(selection - 1, selection + num - 1)
            const beforeText = content.slice(selection - num - 1, selection - 1)
            console.log(afterText)
            console.log(beforeText)
            if (afterText === this.currentText) {
              this.editor.commands.deleteRange({
                from: selection,
                to: selection + num
              })
            } else if (beforeText === this.currentText) {
              this.editor.commands.deleteRange({
                from: selection - num,
                to: selection
              })
            }
          }
        }

        this.editor.commands.insertContentAt(
          typeof this.currentSelection === 'number' ? this.currentSelection : 0,
          `<a target="${
            open ? '_blank' : '_self'
          }" rel="noopener noreferrer nofollow" class="${newText}"  NodeType="${newText}" href="${newUrl}">${text}</a>`,
          {
            updateSelection: false,
            parseOptions: {
              preserveWhitespace: 'full'
            }
          }
        )
      }
      setTimeout(() => {
        this.showLink = false
        this.defaultUrlText = ''
        this.defaultUrlUrl = ''
      }, 0)
      setTimeout(() => {
        this.canSetLink = true
      }, 200)
    },
    insertHtml2(html) {
      this.editor.commands.insertContentAt(this.currentSelection, html, {
        updateSelection: false,
        parseOptions: {
          preserveWhitespace: 'full'
        }
      })
      this.$nextTick(() => {
        this.editor.commands.setTextSelection(this.editor.getText().length + 1)
      })
    },
    toShowFont() {
      if (this.showFonts) {
        this.showFonts = false
      } else {
        this.closeAll()
        this.showFonts = true
      }
    },
    toShowBg() {
      if (this.showBgColor) {
        this.showBgColor = false
      } else {
        this.closeAll()
        this.showBgColor = true
      }
    },
    toShowSize() {
      if (this.showSize) {
        this.showSize = false
      } else {
        this.closeAll()
        this.showSize = true
      }
    },
    toShowColor() {
      if (this.showColor) {
        this.showColor = false
      } else {
        this.closeAll()
        this.showColor = true
      }
    },
    toShowList() {
      if (this.showList) {
        this.showList = false
      } else {
        this.closeAll()
        this.showList = true
      }
    },
    toShowText() {
      if (this.showText) {
        this.showText = false
      } else {
        this.closeAll()
        this.showText = true
      }
    },
    toShowMore() {
      this.closeAll()
      this.showMore = !this.showMore
    },
    clickOut() {
      this.showMore = false
      this.closeAll()
    },
    closeAll() {
      this.showFonts = false
      this.showColor = false
      this.showBgColor = false
      this.showSize = false
      this.showText = false
      this.showList = false
    },
    setColor(color, type) {
      if (type == 'font') {
        this.editor.chain().focus().setColor(color).run()
        this.fontColor = color
      } else {
        this.bgColor = color
        this.editor.chain().focus().toggleHighlight({ color: this.bgColor }).run()
      }
      setTimeout(() => {
        this.closeAll()
      }, 10)
    },
    toRevert() {
      this.editor.chain().focus().unsetAllMarks().run()
      this.defaultFont = this.fonts[0]
      this.editor.chain().focus().setFontFamily(this.defaultFont).run()
    },
    toSetFont(index) {
      this.defaultFont = this.fonts[index]
      this.editor.chain().focus().setFontFamily(this.defaultFont).run()
      setTimeout(() => {
        this.closeAll()
      }, 10)
    },
    toSetSize(index) {
      this.defaultSize = this.sizes[index]
      this.editor
        .chain()
        .focus()
        .setFontSize(this.defaultSize + 'px')
        .run()
      setTimeout(() => {
        this.closeAll()
      }, 10)
    },
    toSetList(index) {
      this.defaultList = this.iconLists[index]
      if (index == 0) {
        this.editor.chain().focus().toggleBulletList().run()
      } else if (index == 1) {
        this.editor.chain().focus().toggleOrderedList().run()
      }
      setTimeout(() => {
        this.closeAll()
      }, 10)
    },
    toSetText(index) {
      this.defaultText = this.iconTexts[index]
      if (index == 0) {
        this.editor.chain().focus().setTextAlign('left').run()
      } else if (index == 1) {
        this.editor.chain().focus().setTextAlign('center').run()
      } else if (index == 2) {
        this.editor.chain().focus().setTextAlign('justify').run()
      } else if (index == 3) {
        this.editor.chain().focus().setTextAlign('right').run()
      }
      setTimeout(() => {
        this.closeAll()
      }, 10)
    },
    beforeImgUpload(file) {
      console.log('beforeImgUpload', file)
    },

    // 选择图片
    handleImgSuccess(res) {
      console.log('handleImgSuccess', res)

      if (res.code === '0000') {
        // console.log(res.data.url);
        this.addImage(`${process.env.VUE_APP_fileBasePath}${res.data.filePath}`)
      }
    },
    handleFileSuccess(res) {
      this.$emit('setFile', res)
    },
    uploadProcess(event) {
      console.log('excess times==================', event)
    },
    addImage(link, selected) {
      const url = link

      if (url) {
        this.editor.chain().focus().setImage({ src: url }).run()
        if (selected) {
          this.editor.commands.setTextSelection(this.currentSelection + 2)
        }
      }
    },
    setLink() {
      console.log(window.innerHeight)
      console.log(this.screenY_)
      console.log(this.$refs.toolNew.offsetTop)

      this.showLink = true

      this.$nextTick(() => {
        if (this.currentText) {
          this.$refs.refEditLink.setData(this.currentText, '', true)
        }
      })
    },
    onBlur(data, data1, data2) {
      this.fonts.forEach((item) => {
        if (this.editor.isActive('textStyle', { fontFamily: item })) {
          this.defaultFont = item
        }
      })
      console.log(this.editor.isActive('textStyle', { fontSize: '16px' }))
      this.sizes.forEach((item) => {
        if (this.editor.isActive('textStyle', { fontSize: item + 'px' })) {
          this.defaultSize = item
        }
      })
      let colors = [
        '#33475b',
        'rgb(255, 2, 1)',
        'rgb(255, 153, 2)',
        'rgb(255, 255, 4)',
        'rgb(0, 255, 3)',
        'rgb(0, 255, 255)',
        'rgb(6, 0, 255)',
        'rgb(154, 0, 255)',
        'rgb(255, 0, 255)',
        'rgb(255, 255, 255)',
        '#F4CCCC',
        '#FCE5CD',
        '#FFF2CC',
        '#D9EAD3',
        '#D0E0E3',
        '#CFE2F3',
        '#D9D2E9',
        '#EAD1DC',
        '#FAFAFA',
        '#EA9999',
        '#F9CB9C',
        '#FFE599',
        '#B6D7A8',
        '#A2C4C9',
        '#9FC5E8',
        '#B4A7D6',
        '#D5A6BD',
        '#EEEEEE',
        '#E06666',
        '#F6B26B',
        '#FFD966',
        '#93C47D',
        '#76A5AF',
        '#6FA8DC',
        '#8E7CC3',
        '#C27BA0',
        '#CCCCCC',
        '#CC0201',
        '#E69138',
        '#F1C233',
        '#69A84F',
        '#45818E',
        '#3D85C6',
        '#674EA7',
        '#A64D79',
        '#999999',
        '#990100',
        '#B45F06',
        '#BF9002',
        '#37761D',
        '#134F5C',
        '#0C5394',
        '#351C75',
        '#741B47',
        '#666666',
        '#660000',
        '#783F04',
        '#7F6001',
        '#274E13',
        '#0C343D',
        '#073763',
        '#20124D',
        '#4C1130'
      ]
      let hasColor = false,
        hasBgColor = false
      colors.forEach((item) => {
        if (this.editor.isActive('textStyle', { color: item })) {
          this.fontColor = item
          hasColor = true
        }
      })
      colors.forEach((item) => {
        if (this.editor.isActive('highlight', { color: item })) {
          this.bgColor = item
          hasBgColor = true
        }
      })
      if (!hasColor) {
        this.fontColor = '#33475b'
      }
      if (!hasBgColor) {
        this.bgColor = 'rgb(255, 255, 255)'
      }
      this.$emit('onBlur')
    }
  }
}
</script>
<style lang="less" scoped>
.editors {
  // min-height: 96px;
  position: relative;
  border: 1px solid #c6d1dd;
  .tools {
    width: 100%;
    height: 48px;
    display: flex;
    align-items: center;
    padding: 0 8px;
    background: #f5f8fa;
    border-bottom: 1px solid #c6d1dd;
  }
  .content {
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-family: OpenSans;
    color: #33475b;
    padding: 8px;
    /deep/.ProseMirror {
      flex: 1;
      height: 100%;
    }
  }
}
.video-upload-state {
  padding: 8px 12px;
  border-top: 1px solid #c6d1dd;
  color: #5f6368;
  font-size: 12px;

  .el-progress {
    margin-top: 6px;
  }
}
button {
  width: 24px;
  height: 27px;
  margin-right: 4px;
  outline-width: 0px;
  border-radius: 3px;
  overflow: visible;
  background-color: rgba(255, 255, 255, 0);
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0);
  &:hover {
    border: 1px solid rgb(203, 214, 226);
  }
  .iconfont {
    color: #425b76;

    font-size: 16px;

    &.iconCam_On {
      font-size: 10px;
      display: block;
      transform: translateY(1px);
    }
  }
}
.insert {
  cursor: pointer;
  .insert-btn {
    height: 40px;
    width: 92px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &-name {
      font-family: OpenSans-Bold;
      font-size: 14px;
      color: #0091ae;
    }
    .iconfont {
      font-size: 16px;
      color: #7c98b6;
    }
    &:hover {
      .insert-btn-name {
        color: #007a8c;
      }
    }
  }
}

.lists {
  padding: 0 0px;
  width: 30px;
  justify-content: space-between;
  overflow: visible;
  .clickB {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .iconfont {
    font-size: 16px;
  }
  .iconarrow_drop_down-24px {
    font-size: 16px;
    margin-left: -4px;
  }

  .listsMenu1 {
    bottom: 28px !important;
    top: unset !important;
  }
  .listsMenu2 {
    bottom: 28px !important;
    top: unset !important;
  }
  .listsMenu {
    position: absolute;
    left: 0;
    top: 28px;
    z-index: 10;
    border-radius: 2px;
    background-color: rgb(255, 255, 255);
    overflow: hidden;
    border: 1px solid #dfe3eb;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
    width: 44px;
    padding: 8px 0;
    .item {
      width: 44px;
      height: 28px !important;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #425b76;
      overflow: hidden;
      border-radius: 0px;
      .iconfont {
        font-size: 20px;
      }
      &:hover {
        background-color: #e5f5f8;
      }
    }
  }
}
.line {
  width: 1px;
  height: 24px;
  margin-left: 4px;
  margin-right: 8px;
  background-color: #dfe3eb;
}
.more {
  //height: 20px;
  display: flex;
  position: relative;
  align-items: center;
  margin-right: 4px;
  // margin-left: 4px;
  z-index: 22;
  cursor: pointer;

  .selectedStyle {
    background-color: #e5f5f8;
  }
  span {
    font-size: 14px;
    font-family: OpenSans-Bold1;
    color: #0091ae;
  }
  .iconarrow_drop_down-24px {
    color: #7c98b6;
  }
  &:hover {
    span {
      text-decoration: underline;
      color: #007a8c;
    }
    .menu {
      display: flex;
    }
  }
  .menu {
    // width: 424px;
    height: 48px;
    display: flex;
    align-items: center;
    padding: 8px 8px 8px 8px;
    border-radius: 2px;
    border: 1px solid #dfe3eb;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
    position: absolute;
    left: 0;
    bottom: 32px;
    background-color: #fff;
    .line1 {
      width: 1px;
      height: 24px;
      margin-left: 4px;
      margin-right: 8px;
      background-color: #dfe3eb;
    }
  }
}
.font {
  width: 112px;
  height: 32px;
  display: flex;
  background-color: #eaf0f6;
  align-items: center;
  padding: 8px;
  border-radius: 2px;
  border: 1px solid #cbd6e2;
  position: relative;
  color: #33475b;
  font-size: 12px;
  margin-right: 8px;
  font-family: OpenSans;
  .clickBtn {
    width: 104px;
  }
  .iconarrow_drop_down-24px {
    color: #7c98b6;
    position: absolute;
    right: 5px;
  }
  &:hover {
    background-color: #f5f8fa;
  }
  .fontsMenuTop {
    top: unset !important;
    bottom: 34px !important;
  }
  .fontsMenu {
    position: absolute;
    left: 0;
    top: 34px;
    background-color: #fff;
    border-radius: 2px;
    overflow: hidden;
    border: 1px solid #dfe3eb;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
    width: 112px;
    padding: 8px 0;
    .item {
      width: 112px;
      height: 28px !important;
      padding: 0 8px;
      display: flex;
      align-items: center;
      justify-content: left;
      overflow: hidden;
      border-radius: 0px;
      color: #33475b;
      font-size: 12px;
      font-family: OpenSans;

      &:hover {
        background-color: #e5f5f8;
      }
    }
  }
  //&:hover {
  //  background-color: ;
  //}
}
.fontS {
  margin-right: 4px;
  width: 48px;
  .clickBtn {
    width: 40px;
  }
  .sizesMenu {
    width: 48px;
    z-index: 20;
    .item {
      width: 48px !important;
    }
  }
}

.is-active {
  background-color: rgb(203, 214, 226);
  border: 1px solid rgb(153, 172, 194);
  &:hover {
    border: 1px solid rgb(153, 172, 194);
  }
}
.fixedS {
  position: fixed;
  height: 332px;
  width: 0;
}

.modal {
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
}
.modal-item {
  width: 244px;
  height: 36px;
  display: flex;
  align-items: center;
  padding: 0px 28px 0 12px;
  border: 1px solid #eaf0f6;
  margin: 8px 8px 0 0;
  position: relative;
  background-color: #f5f8fa;
  .iconattach_file-24px {
    color: #33475b;
    margin-right: 8px;
    font-size: 16px;
  }
  .name {
    display: inline-block;
    color: #0091ae;
    max-width: 124px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: OpenSans-Bold;
    white-space: nowrap;
    margin-right: 4px;
    &:hover {
      color: #007a8c;
      text-decoration: underline;
    }
  }
  .size {
    color: #7c98b6;
  }
  .iconClose_24px {
    color: #7c98b6;
    position: absolute;
    font-size: 16px;
    right: 12px;
  }
}
</style>

<style lang="less">
/* Basic editor styles */
.ProseMirror-focused {
  border: none !important;
  outline: none !important;
}
.ProseMirror {
  height: 100%;
}
.ProseMirror {
  > * + * {
    //margin-top: 0.75em;
  }

  ul,
  ol {
    padding: 0 1rem;
  }
  ul {
    list-style: disc !important;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    line-height: 1.1;
  }

  code {
    background-color: rgba(#616161, 0.1);
    color: #616161;
  }

  pre {
    background: #0d0d0d;
    color: #fff;
    font-family: 'JetBrainsMono', monospace;
    padding: 0.75rem 1rem;
    border-radius: 0.5rem;

    code {
      color: inherit;
      padding: 0;
      background: none;
      font-size: 0.8rem;
    }
  }

  img {
    max-width: 100%;
    height: auto;
  }

  blockquote {
    padding-left: 1rem;
    border-left: 2px solid rgba(#0d0d0d, 0.1);
  }

  hr {
    border: none;
    border-top: 2px solid rgba(#0d0d0d, 0.1);
    margin: 2rem 0;
  }
  .mention {
    color: #425b76;
    font-family: OpenSans-Bold1 !important;
    box-decoration-break: clone;
  }
  a {
    cursor: pointer;
    font-size: 16px !important;
    font-family: OpenSans-Bold1 !important;
    color: #0091ae !important;
    &:hover {
      color: #007a8c !important;
      text-decoration: underline !important;
    }
  }
}
.ProseMirror p.is-editor-empty:first-child::before {
  color: #b4b4b4;
  font-size: 14px;
  font-family: OpenSans;
  content: attr(data-placeholder);
  float: left;
  height: 0;
  pointer-events: none;
}
.ProseMirror p.is-empty::before {
  color: #b4b4b4;
  content: attr(data-placeholder);
  float: left;
  height: 0;
  font-size: 14px;
  font-family: OpenSans;
  pointer-events: none;
}
</style>
